import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { logout } from '../services/api'
import SecureLS from 'secure-ls';
import { clearUserData } from '../utils/userUtils';
import { removeUser, removeFamilies } from '../utils/secureStorage';

function Logout() {
    const navigate = useNavigate()
    const ls = new SecureLS({ encodingType: 'aes' });
    const [error, setError] = useState('');

    useEffect(() => {
        async function performLogout() {
            try {
                await logout()
                removeUser()
                removeFamilies()
                localStorage.removeItem('familyId')
                localStorage.removeItem('primaryFamilyId')
                localStorage.removeItem('isLoggedIn')
                ls.remove('authToken')
                clearUserData() // Clear user's first name
                navigate('/', { replace: true })
            } catch (error) {
                console.error('Logout failed:', error)
                setError('Logout failed. Please try again.')
                // Navigate to home page after a short delay
                setTimeout(() => navigate('/', { replace: true }), 3000)
            }
        }

        performLogout()
    }, [navigate])

    return (
        <div className="min-h-screen bg-background flex items-center justify-center">
            <div className="text-center">
                {error ? (
                    <h2 className="text-2xl font-bold mb-4 text-red-500">{error}</h2>
                ) : (
                    <>
                        <h2 className="text-2xl font-bold mb-4">Logging out...</h2>
                        <p>Please wait while we log you out.</p>
                    </>
                )}
            </div>
        </div>
    )
}

export default Logout
